class ManageMyRlinkCategoriesController {
  constructor ($state, I18n) {
    'ngInject'
    this.$state = $state
    this.I18n = I18n
    this.categories = [{
      id: 'myPurchaseRecords',
      label: 'manageMyRlink.categories.history'
    }, {
      id: 'myUpdates',
      label: 'manageMyRlink.categories.updates'
    }]
  }

  active (categoryId) {
    return this.$state.is('vehicle.manageMyRlink.' + categoryId)
  }
}

export default ManageMyRlinkCategoriesController



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/manage-my-rlink/components/categories/manage-my-rlink-categories.controller.js